import React from "react";
// import { Link } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";

import headshot from "../images/GoforthNewestHeadshot.jpg"
import hammock from "../images/family/Hammock.jpg";
import alaska1 from "../images/family/Alaska2Sm.jpg";
import alaska2 from "../images/family/Alaska4Sm.jpg";
import hawaii1 from "../images/family/Hawaii1Sm.jpg";
import hawaii2 from "../images/family/Hawaii3Sm.jpg";
import newYork from "../images/family/NewYorkSm.jpg";

function IndexPage() {
  return (
    <Layout title="About Jonathan">
      <SEO title="About Jonathan" />

      <section>
        <div className="max-w-6xl mx-auto pb-3">
          <div className="flex flex-col md:flex-row items-start space-y-4 md:space-y-0 md:space-x-6 items-center">
            <div className="justify-left">
              <img alt="Jonathan Pointing" src={headshot} className="border-2 border-black rounded object-contain h-80" />
            </div>
            <div className="flex-1 md:pl-10">
              <p className="leading-relaxed">
                Jonathan Goforth loves to sell houses! He has SOLD hundreds of homes during his successful 30-year career. He was listed in <b>Forbes Magazine</b> in 2019, 2020 and 2021, representing Kansas City as one of the &quot;Top Market Leaders in Real Estate in the Nation.&quot; He was then listed in <b>Fortune Magazine</b> in 2022 on the &quot;Top 500 List&quot; nationally. Those articles were published by Five-Star Professionals. Jonathan is a published author of the book: HOW TO SELL HOMES IN A TOUGH MARKET, available at Barnes & Noble, Amazon and on Kindle. &quot;Jonathan Goforth Show&quot; on YouTube has 1.3 Million Subscribers.
              </p>
            </div>
          </div>
        </div>
      </section>

      <p className="leading-relaxed">
        &quot;SELLING KANSAS CITY&quot; is the hit TV Show produced by the Emmy-Nominated American Dream. Jonathan is excited to have been selected as one of the Realtors hosting the show. It airs on TheCW, Roku, AppleTV, AmazonFire and FOX. This hit TV Show has received numerous Telly Awards as well as Emmy nominations. Click to the right to view TV Episodes.
      </p>
      <p className="leading-relaxed pt-3">
        In addition to selling homes, Jonathan enjoys teaching real estate classes to train other realtors. His family runs five YouTube channels, three monetized, with more than 45 million views. Jonathan volunteers to teach social media growth strategies through area high schools and the Future Business Leaders of America, and is a 2026 alumni award recipient from the Grandview Education Foundation, receiving the "Alumni of the Year - Jane Bryan Award of Distinction". He is currently a volunteer judge for FBLA at UMKC's School of Business and the published author of How to Sell Homes in a Tough Market (Barnes & Noble). Most recently, Jonathan taught an in-depth Social Media Strategies class, to a large crowd of realtors at the Kansas City Regional Association of Realtors (KCRAR). How to get a following on Facebook, TikTok, YouTube and Instagram. <a className="text-blue-500 cursor-pointer" href="https://www.youtube.com/@jonathangoforthshow7427" target="_blank" rel="noopener noreferrer">Visit his YouTube channel:  &quot;Jonathan Goforth Show.&quot;</a>
      </p>      

      <section className="pt-3">
        <div className="flex">
          <div className="w-1/2"><img src={alaska1} alt="Family Alaska" className="border-2 border-black rounded object-contain" /></div>
          <div className="w-1/2"><img src={alaska2} alt="Family Alaska" className="border-2 border-black rounded object-contain" /></div>
        </div>
      </section>

      {/* <section>
        <p className="leading-relaxed pt-3">
          Jonathan spent his first 18 years with ReeceNichols Realtors where he rose to be one of the top-selling Realtors in Kansas City and enjoyed speaking at numerous events. He moved to Keller Williams Platinum Partners a few years ago and created the Goforth Team with an impressive lineup of real estate agents.  <Link to='/meet-the-team' className="text-blue-500 cursor-pointer">Please see &quot;Meet The Team&quot;</Link>.
        </p>
      </section> */}

      <section className="pt-3">
        <div className="grid grid-rows-1 grid-flow-col gap-2">
          <div><img src={hammock} alt="Hammock" className="border-2 border-black rounded object-contain" /></div>
          <div><img src={hawaii1} alt="Hawaii" className="border-2 border-black rounded object-contain" /></div>
          <div><img src={hawaii2} alt="Hawaii" className="border-2 border-black rounded object-contain" /></div>
        </div>
      </section>

      <section>
        <p className="leading-relaxed pt-3 pb-3">
          Jonathan graduated from Missouri State University with a degree in Business & Marketing. He played trombone in the Bruin Pride Marching Band during college. He and his wife, Carrie, live in Lee&apos;s Summit with their three children. Jonathan was ordained in the ministry as a Deacon in 2009 at Connection Point Church (previously called First Baptist Raytown) and served as Chairman of Deacons as well as serving on numerous church committees. They now attend Abundant Life.
        </p>
      </section>

      <section>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
            <div className="md:mt-0">
              <div className="flex justify-left">
                <img alt="New York" src={newYork} className="border-2 border-black rounded object-contain h-80" />
              </div>
            </div>
            <div>
              <p className="leading-relaxed pb-3">{`The Goforth Team has won numerous awards in both sales and excellence in customer service and is one of the most successful teams in greater Kansas City.`}</p>
              <p className="leading-relaxed">Contact Jonathan directly at <b>816-830-7575</b> for your real estate needs!</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default IndexPage;
